import type { ContractPricingMode, Milestone } from '../types';

/** All inputs describe this stage. Contract totals are a preview, never an input. */
export function milestoneFormAmounts(
  milestones: Milestone[],
  selectedId: string | undefined,
  stageAmount: number,
  stageGrossAmount: number,
  previousContractAmount: number,
  pricingMode: ContractPricingMode = 'top_down',
  stageRotAmount = 0
) {
  const otherPayableOre = milestones
    .filter(milestone => milestone.id !== selectedId)
    .reduce((sum, milestone) => sum + Math.round(milestone.afterRotAmount * 100), 0);
  const bottomUp = pricingMode === 'bottom_up';
  const stageGrossOre = Math.round((bottomUp ? stageAmount : stageGrossAmount) * 100);
  const stageRotOre = bottomUp ? Math.round(stageRotAmount * 100) : stageGrossOre - Math.round(stageAmount * 100);
  const payableOre = otherPayableOre + stageGrossOre - stageRotOre;
  const grossOre = bottomUp
    ? milestones.filter(milestone => milestone.id !== selectedId).reduce((sum, milestone) => sum + Math.round(milestone.amount * 100), stageGrossOre)
    : Math.round(previousContractAmount * 100) + stageGrossOre - Math.round((milestones.find(milestone => milestone.id === selectedId)?.amount ?? 0) * 100);
  const rotOre = grossOre - payableOre;
  const stageValid = Number.isSafeInteger(stageRotOre) && (stageRotOre === 0 || (Math.sign(stageRotOre) === Math.sign(stageGrossOre) && Math.abs(stageRotOre) <= Math.abs(stageGrossOre)));
  const valid = stageValid && Number.isSafeInteger(payableOre) && Number.isSafeInteger(grossOre) &&
    (rotOre === 0 || (grossOre !== 0 && Math.sign(rotOre) === Math.sign(grossOre) && Math.abs(rotOre) <= Math.abs(grossOre)));
  return {
    total: grossOre / 100,
    afterRot: payableOre / 100,
    rot: rotOre / 100,
    change: (grossOre - Math.round(previousContractAmount * 100)) / 100,
    valid
  };
}
